import {
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import { BranchDetails } from "../../../api/branchDetails";
import {
  fetchBranchDetails,
  upsertBranchDetails,
} from "./branchDetailsThunks";

export const branchDetailsAdapter = createEntityAdapter<BranchDetails, string>({
  selectId: (branch) => branch.branch_id,
});

const initialState = branchDetailsAdapter.getInitialState();

const branchDetailsSlice = createSlice({
  name: "branchDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchDetails.fulfilled, (state, action) => {
        branchDetailsAdapter.upsertMany(state, action.payload ?? []);
      })

      .addCase(upsertBranchDetails.fulfilled, (state, action) => {
        branchDetailsAdapter.upsertOne(state, action.meta.arg);
      });
  },
});

export const branchDetailsReducer = branchDetailsSlice.reducer;

const branchDetailsSelectors = branchDetailsAdapter.getSelectors<RootState>(
  (state) => state.branchDetails,
);

export const {
  selectAll: getAllBranchDetails,
  selectById: getBranchDetailById,
  selectEntities: getBranchDetailEntities,
  selectIds: getBranchDetailIds,
  selectTotal: getBranchDetailCount,
} = branchDetailsSelectors;

export const getBranchDetailByBranchId = createSelector(
  [
    getBranchDetailEntities,
    (_state: RootState, branchId?: string) => branchId,
  ],
  (entities, branchId) => (branchId ? entities[branchId] : undefined),
);